export default "__VITE_ASSET__9546ca36__"